import styled from 'styled-components';

export const ChartContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 32px;
  min-height: 200px;
  width: 100%;

  @media (max-width: ${({ theme }) => theme.breakpoints.Tablet}) {
    flex-direction: column;
    align-items: center;
  }
`;

export const LegendContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const LegendDot = styled.div<{ $color: string }>`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: ${({ $color }) => $color};
  flex-shrink: 0;
`;

export const LegendLabel = styled.span`
  ${({ theme }) => theme.fonts.PoppinsText};
  font-size: 13px;
  color: ${({ theme }) => theme.colors.TextDarkGrey};
`;

export const LegendValue = styled.span`
  ${({ theme }) => theme.fonts.PoppinsBold};
  font-size: 13px;
  color: ${({ theme }) => theme.colors.TextDarkGrey};
  margin-left: auto;
`;
